<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 3.5rem">
      <el-row type="flex" justify="space-between">
        <div class="sub-title">
          患者：
          <span style="font-weight:bold;" v-if="entity && entity.name">
            {{entity.name}}
          </span>
          <i
            @click="handleClear"
            v-if="entity && entity.name"
            class="el-icon-delete"
            title="移除"
            style="margin: 0 15px; cursor: pointer; color: #ccc"
          >
          </i>
          <el-button icon="el-icon-document-add" @click="create" size="small" type="primary" class="left-pad">患者注册</el-button>
          <el-button icon="el-icon-s-check" @click="chronic" size="small" type="primary" class="left-pad">慢特病备案</el-button>
          <el-button icon="el-icon-s-check" @click="fixed" size="small" type="primary" class="left-pad">定点备案</el-button>
          <el-button icon="el-icon-s-custom" @click="meta.showTrtinfo = true" size="small" type="primary" class="left-pad">人员待遇享受检查</el-button>
        </div>
        <div>
          <el-input v-model="condition.keyword" placeholder="患者姓名或卡号" size="small" v-on:keyup.enter.native="queryEntities(1)" class="condition-wide" clearable>
            <el-button type="info" :loading="searchLoading" slot="append" icon="el-icon-search" @click="queryEntities(1)">查询</el-button>
          </el-input>
        </div>
      </el-row>
    </el-header>
    <el-main style="padding: 0px">
      <el-table v-loading="searchLoading" @filter-change="filterChanged" height="100%" :data="entities.items" highlight-current-row @current-change="handleCurrentChange" @sort-change="handleSortChange" class="main-table">
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" title="编辑" plain circle size="mini" @click="edit(scope.row, scope.$index)"></el-button>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="卡号" prop="code" min-width="80" align="center" />
        <el-table-column sortable="custom" label="姓名" prop="name" min-width="80" align="center" />
        <el-table-column sortable="custom" prop="patientAge" column-key="patientAge" label="年龄" min-width="80" align="right"></el-table-column>
        <el-table-column sortable="custom" :filters="dict.Gender" :filter-multiple="false" column-key="gender" label="性别" prop="gender" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.gender | dictText("Gender") }}
          </template>
        </el-table-column>
        <el-table-column column-key="insuranceNo" prop="insuranceNo" sortable="custom" label="患者类型" min-width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.insuranceNo" type="success" effect="plain" size="mini">社保</el-tag>
            <el-tag v-else type="info" effect="plain" size="mini">自费</el-tag>
          </template>
        </el-table-column>
        <el-table-column sortable="insuranceNo" label="医保个人编号" prop="insuranceNo" width="180" align="center" />
        <el-table-column sortable="custom" label="病案号" prop="recordNo" min-width="90" align="center" />
        <el-table-column sortable="custom" prop="ethnicity" label="民族" :filters="dict.Ethnicity" :filter-multiple="false" column-key="ethnicity" min-width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.ethnicity | dictText("Ethnicity") }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="籍贯" prop="nativePlaceProvince" :filters="filPro" :filter-multiple="false" column-key="nativePlaceProvince" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.nativePlaceProvince">
              {{ `${scope.row.nativePlaceProvince}${scope.row.nativePlaceCity}${scope.row.nativePlaceDistrict ||""}` }}
            </span>
          </template>
        </el-table-column>
        <!--<el-table-column sortable="custom" label="备注" prop="memo" />-->
      </el-table>
    </el-main>
    <pagination :entities="entities" @queryEntities="queryEntities" :condition="condition" />
    <editor @saved="queryEntities" v-model="entity" :visible.sync="meta.showEditor" />
    <fixed v-model="entity" :visible.sync="meta.showFixed" v-if="meta.showFixed"></fixed>
    <chronic v-model="entity" :visible.sync="meta.showChronic" v-if="meta.showChronic"></chronic>
    <trtinfo :prop-data="entity" :visible.sync="meta.showTrtinfo" v-if="meta.showTrtinfo"></trtinfo>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import api from './api';
import { CodeToText, TextToCode } from "element-china-area-data";
import provinceCode from "./provinceCode.js";

export default {
  components: {
    editor: () => import("./editor"),
    fixed: () => import("./fixed"),
    chronic: () => import("./chronic"),
    pagination: () => import("@/components/_com/pagination"),
    trtinfo: () => import("./trtinfo"),
  },
  computed: {
    ...mapGetters(["dict"]),
    filPro () {
      return this.provinceData.map(m => ({ text: m.label, value: m.value }));
    }
  },
  data () {
    return {
      searchLoading: false,
      provinceData: provinceCode,
      meta: {
        showEditor: false,
        showFixed: false,
        showChronic: false,
        showTrtinfo: false,
      },
      // medCode: this.$store.state.medCode,
      entity: {},
      condition: {
        sort: "id",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 20
      },
      entities: {
        items: []
      }
    };
  },
  created () {
    this.queryEntities();
  },
  mounted () { },
  methods: {
    fixed () {
      this.$set(this, "entity", JSON.parse(JSON.stringify(this.entity)));
      this.meta.showFixed = true;
    },
    chronic () {
      this.$set(this, "entity", JSON.parse(JSON.stringify(this.entity)));
      this.meta.showChronic = true;
    },
    handleSortChange ({ prop, order }) {
      this.condition.asc = order === "ascending";
      this.condition.sort = prop;
      this.queryEntities();
    },
    filterChanged (options) {
      if (options.nativePlaceProvince && options.nativePlaceProvince[0]) {
        options.nativePlaceProvince = [
          CodeToText[options.nativePlaceProvince[0]]
        ]; //籍贯字段过滤
      }
      Object.assign(this.condition, options);
      this.queryEntities();
    },
    edit (val) {
      this.$set(this, "entity", JSON.parse(JSON.stringify(val)));
      this.meta.showEditor = true;
    },
    queryEntities () {
      this.searchLoading = true;
      api
        .queryPatient(this.condition)
        .then(res => {
          this.entities = res;
          this.searchLoading = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    create () {
      this.$set(this, "entity", {
        idType: "SF",
      });
      this.meta.showEditor = true;
    },
    handleCurrentChange (val) {
      this.entity = val;
    },
    handleClear () {
      this.entity = {}
    }
  }
};
</script>

<style scoped>
.condition-wide {
  width: 15rem;
  margin-left: 0.5rem;
  color: #a5a1a1;
}
</style>
